import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#4a90e2',
        secondary: '#b0bec5',
        anchor: '#8c9eff',
        primary1: '#5fbff5'
      },
    },
  }
});
